import { TaskList } from "@/components/TaskList";
import { useDataProvider } from "@/providers/DataProvider";
import { useParams } from "react-router-dom";
import { SectionHeader } from "@/components/SectionHeader";

export const CategoryPage = () => {
  const { tasks, categories, tags } = useDataProvider();
  let params = useParams();

  const categoryId = params.categoryId;

  const filteredTasks = tasks.filter((task) => task.categoryId === categoryId);

  return (
    <>
      <SectionHeader
        title={(() => {
          const category = categories.find((cat) => cat.id === categoryId);
          return category
            ? `Tasks in category: ${category.getName()}`
            : "Category Tasks";
        })()}
        showAddTask={true}
      />
      <TaskList
        tasks={filteredTasks}
        categories={categories}
        tags={tags}
        showCategoryName={false}
      />
    </>
  );
};
